module.exports = __webpack_public_path__ + "static/logo-a011d153baa2515b2b6197f4dda577c6.svg";